import { Omit, Replace } from '@40seas/entities/common';
import { TenantlessBaseEntityFieldsArray } from '@40seas/models';
import { Lead } from './lead.entity';
import { z } from 'zod';

export class CreateLeadDto extends Omit(
    Replace(Lead, [
        {
            fieldName: 'legalName',
            newFieldSchema: z
                .string()
                .regex(/^[a-zA-Z0-9\s.'-_]+$/, 'Business name is not Valid')
                .min(2)
                .max(250),
        },
    ]),
    TenantlessBaseEntityFieldsArray,
    ['status'],
) {}
